export default function IconMinus({ width = 13, height = 13 }: { width?: number; height?: number }) {
  return (
    <svg width={width} height={height} viewBox="0 0 13 2" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13 0.75C13 1.1875 12.6562 1.5 12.25 1.5H0.75C0.3125 1.5 0 1.1875 0 0.75C0 0.34375 0.3125 0 0.75 0H12.25C12.6562 0 13 0.34375 13 0.75Z"
        fill="currentColor"
      />
    </svg>
  );
}
